import { UntypedFormGroup } from "@angular/forms";

export function tasksUpdateValidator(form: UntypedFormGroup) {
	const validateControl = form.get("executed");
	const importantControl = form.get("important");
	const initializeDarControl = form.get("initializeDar");
	const notesControl = form.get("notes");

	// @ts-expect-error TS18047
	if ((importantControl.value || initializeDarControl.value) && !notesControl.value) {
		return {
			checkValidator: {
				valid: false,
			},
		};
	}

	// @ts-expect-error TS18047
	if (validateControl.value === true) {
		return null;
	}

	// Dynamic task can be executed without notes
	// Remove `if` statement if notes are mandatory on dynamic task
	// @ts-expect-error TS18047
	if (validateControl.value === null) {
		return null;
	}

	// @ts-expect-error TS18047
	return !validateControl.value && notesControl.value
		? null
		: {
				checkValidator: {
					valid: false,
				},
			};
}
